// Skool-style community: categories, points and levels. Pure and SDK-free.
//
// Points (Dew, 2026-10-17): finished lessons + time on the site, scored by
// Cloud Functions (functions/src/points.ts) into members/{uid}.points, never
// by the client. Likes only count likes, they earn no points.

export const CATEGORIES = ["ทั่วไป", "โชว์ผลงาน", "ถาม-ตอบ", "ประกาศ"] as const;

/** Points needed to reach each level, Skool's own ladder (index 0 = level 1). */
export const LEVEL_THRESHOLDS = [0, 5, 20, 65, 155, 515, 2015, 8015, 33015];

export function levelForPoints(points: number): number {
  let level = 1;
  LEVEL_THRESHOLDS.forEach((min, i) => {
    if (points >= min) level = i + 1;
  });
  return level;
}

/** Points still missing to reach the next level; null at the top level. */
export function pointsToNextLevel(points: number): number | null {
  const next = LEVEL_THRESHOLDS[levelForPoints(points)];
  return next === undefined ? null : next - points;
}

/** "5 นาทีที่แล้ว" style relative time for feed cards. */
export function timeAgo(date: Date, now = new Date()): string {
  const s = Math.max(0, Math.floor((now.getTime() - date.getTime()) / 1000));
  if (s < 60) return "เมื่อสักครู่";
  if (s < 3600) return `${Math.floor(s / 60)} นาทีที่แล้ว`;
  if (s < 86400) return `${Math.floor(s / 3600)} ชั่วโมงที่แล้ว`;
  if (s < 86400 * 7) return `${Math.floor(s / 86400)} วันที่แล้ว`;
  return date.toLocaleDateString("th-TH");
}

/** Pinned first (Skool keeps announcements on top), then newest. Non-mutating. */
export function sortFeed<T extends { pinned: boolean; createdAt: Date }>(posts: T[]): T[] {
  return [...posts].sort((a, b) => {
    if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
    return b.createdAt.getTime() - a.createdAt.getTime();
  });
}
